var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-text-type-container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"result-text-type-response"},[_c('p',[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }